import * as React from 'react';

import { useNavigate, useParams } from 'react-router-dom';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';

import AuthLayout, { TRUE_DARK, primaryButtonSx } from './auth/AuthLayout';

const baseUrl = process.env.REACT_APP_BASE_URL || '';

const PasswordReset = () => {
    const navigate = useNavigate();

    const { uid, token } = useParams<{ uid: string, token: string}>();

    const [password, setPassword] = React.useState<string>('');
    const [password2, setPassword2] = React.useState<string>('');

    const [loading, setLoading] = React.useState<boolean>(false);

    const handlePasswordReset = async () => {
        if (password !== password2) {
            alert('Las contraseñas no coinciden');
            return;
        }
        setLoading(true);
        try {
            const response = await fetch(`${baseUrl}/management/password-reset/${uid}/${token}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    password,
                    password2,
                }),
            });
            setLoading(false);
            if (response.status === 200) {
                navigate("/login");
            }
        } catch (error) {
            alert('Ha ocurrido un error');
        }
    }


    return (
        <AuthLayout title="Restablece tu contraseña" subtitle="Ingresa tu nueva contraseña.">
            {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
                    <CircularProgress sx={{ color: TRUE_DARK }} />
                </Box>
            ) : (
                <>
                    <TextField
                        id='password'
                        label='Contraseña'
                        variant='outlined'
                        fullWidth
                        margin='normal'
                        size='small'
                        type='password'
                        autoComplete='new-password'
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <TextField
                        id='password2'
                        label='Confirmar contraseña'    
                        variant='outlined'
                        fullWidth
                        margin='normal'
                        size='small'
                        type='password'
                        autoComplete='new-password'
                        sx={{ mb: 3 }}
                        onChange={(e) => setPassword2(e.target.value)}
                    />
                    <Button variant='contained' fullWidth sx={primaryButtonSx} onClick={handlePasswordReset}>
                        Restablecer contraseña
                    </Button>
                </>
            )}
        </AuthLayout>
    );
}

export default PasswordReset;
